import React from "react";
import { Redirect } from "react-router-dom";
import Form from "./common/form";
import auth from "../services/authService";
import { Typography } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import { NavLink } from "react-router-dom";
import { fieldValidator } from "./common/fieldValidator";

export class ForgotPasswordUpdateForm extends Form {
    state = {
        message: "",
        data: { password: "" },
        errors: {},
        error: "",
		showLoginButton: false,
		isSubmitting: false
    };

    doSubmit = async () => {
		if (this.state.isSubmitting || this.state.showLoginButton) return;
		this.setState({ isSubmitting: true });
        try {
            const { data } = this.state;
			const passwordError = fieldValidator("password", data.password);
			if (passwordError) {
				this.setState({ errors: { password: passwordError } });
				return;
			}
            const response = await auth.forgotPasswordUpdate(this.props.match.params.id, this.props.match.params.code, data.password);
			if(response.data.status === "error") {
				this.setState({ error: response.data.message || "Hiba történt a jelszó frissítése közben!" });
                this.setState({ message: "" });
            } else {
                this.setState({ message: "Sikeres mentés!", error: "", showLoginButton: true });
            }
        } catch (ex) {
			const message = ex.response && ex.response.data && ex.response.data.message;
			this.setState({ error: message || "Átmeneti hiba, kérjük próbálja meg pár perc múlva!" });
		} finally {
			this.setState({ isSubmitting: false });
        }
    };

    render() {
        let errorMessages = Object.values(this.state.errors);
        let numberOfErrors = errorMessages.filter(Boolean);
		let isDisabled = numberOfErrors.length > 0 || this.state.isSubmitting;

        return (
            <div>
                <h1>Új jelszó beállítás</h1>

                {this.state.message === "" ? null : (<Typography color="primary">{this.state.message}</Typography>)}

                {this.state.error === "" ? null : (<Typography color="error">{this.state.error}</Typography>)}

                {this.state.showLoginButton ? (<Button color="primary" component={props => <NavLink to="/w/login" {...props}/>}>Tovább a belépéshez</Button>): null}

				{this.state.showLoginButton ? null : (<form onSubmit={this.handleSubmit}>
                    {this.renderInput("password", "Új jelszó", "password")}
                    <br />
                    {this.renderButton("Mentés", isDisabled)}
				</form>)}
            </div>
        );
    }
}

export default ForgotPasswordUpdateForm;
